
const keysOf = (obj) => Object.keys(obj)

export default keysOf



// WEBPACK FOOTER //
// ./src/utils/keysOf.js